jQuery(document).ready(function(){
jQuery('.sticky-navlinks').click(function(e){
  e.preventDefault();
 $('html, body').animate({
        scrollTop: $(jQuery(this).attr('href') + ".marker").offset().top - 150
    }, 250);
}); 
});

const headerHeightVal = document.querySelector('.header-sticky');

window.addEventListener('DOMContentLoaded', (event) => {

  const viewPortWidth = window.innerWidth;
  const STICKYHEADER = {
    height: {
      mobile: `${headerHeightVal.getBoundingClientRect().height}px`,
      desktop: `${headerHeightVal.getBoundingClientRect().height}px`
    },
    offsetHeight: {
      mobile: `${headerHeightVal.getBoundingClientRect().height}px`,
      desktop: `${headerHeightVal.getBoundingClientRect().height}px`
    }
  }
  const COLLECTIONSNAVIGATION = {
    height: {
      mobile: '56px',
      desktop: '64px'
    }
  }
  const heightOfStickySiteHeader = viewPortWidth < 960 ? 
                                    STICKYHEADER.height.mobile : 
                                    STICKYHEADER.height.desktop;
                                   
  function createStickyCollectionNavigation() {
    // Selectors
    const collectionsHeroNavigation = document.querySelector('.collections-page-links > ul');  
    const blackArrowScrollIndicator = document.querySelector('.collections-sticky-nav-arrow');
    const collectionsHero = document.querySelector('.collections-hero');

    // Create and add the sticky navigation into DOM
    const stickyCollectionsNavigation = deepClone(collectionsHeroNavigation);
    document.body.insertBefore(stickyCollectionsNavigation, document.body.firstChild);
    addClass(stickyCollectionsNavigation ,'collections-navigation-bar');

    // Replace ids and classes for for links in cloned node
    const stickyCollectionNavigationLinks = stickyCollectionsNavigation.querySelectorAll('.collection-nav-links');
    stickyCollectionNavigationLinks.forEach(link => {
      link.classList.replace('collection-nav-links', 'sticky-navlinks');
      link.id = `sticky-navlink-${getHandleFromText(link)}`;
    })

    // Set the height where the sticky collections nav should stick (below the site header)
    stickyCollectionsNavigation.style.top = viewPortWidth < 960 ? 
                                            STICKYHEADER.offsetHeight.mobile : 
                                            STICKYHEADER.offsetHeight.desktop;

    // Intersection Observer to make the sticky navigation appear/disappear
    const options = {
      rootMargin: '-' + heightOfStickySiteHeader + ' 0px 0px 0px'
    };
    const elements = [blackArrowScrollIndicator, stickyCollectionsNavigation];
    const observer = createNewIntersectionObserver(toggleDisplayOfStickyNavigation, elements, options);

    observer.observe(collectionsHero);
  }
  createStickyCollectionNavigation();

  function createNewIntersectionObserver(effects, manipulatedElements, options={}) {
    const observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(entry => {

        effects(entry, manipulatedElements);
      })
    }, options)

    return observer;
  }
  function toggleDisplayOfStickyNavigation(entry, elements) {
    const [blackArrowScrollIndicator, stickyCollectionsNavigation] = elements;

    if (entry.isIntersecting) {
      if (viewportWidthIsSmall()) hide(blackArrowScrollIndicator);
      hide(stickyCollectionsNavigation);
    } else {
      // if (viewportWidthIsSmall()) show(blackArrowScrollIndicator);
      //show(stickyCollectionsNavigation);
    }
  }
  function changeLinkToActiveState(entry, elements) {
    if(entry.isIntersecting) {
      const correspondingCollectionName = getHandleFromText(entry.target.querySelector('h4'));
      const correspondingAnchorTagId = 'sticky-navlink'.concat('-', correspondingCollectionName);
      const correspondingAnchorTag = document.querySelector(`#${correspondingAnchorTagId}`);

      resetStickyLinksToInactiveState();
      addClass(correspondingAnchorTag, 'sticky-link-active');
      }
  }
  function deepClone(element) {
    return element.cloneNode(true);
  }
  function previousCousin(element, parent) {
    return element.target.closest(parent).previousSibling.previousSibling;
  }
  function nextCousin(element, parent) {
    return element.target.closest(parent).nextSibling.nextSibling;
  }
  function addClass(element, className) {
    element.classList.add(className);
  }
  function removeClass(element, className) {
    element.classList.remove(className);
  }
  function hide(element) {
    removeClass(element, 'is-flexed');
  }
  function show(element) {
    addClass(element, 'is-flexed');
  }
  function viewportWidthIsSmall(small=500) {
    return window.innerWidth <= small;
  }
  function resetStickyLinksToInactiveState() {
    const stickNavlinks = document.querySelectorAll('.sticky-navlinks');
    
    stickNavlinks.forEach(function(link) {
      removeClass(link, 'sticky-link-active');
    })     
  }
  function getElementsWithClass(className) {
    return document.querySelectorAll('.' + className);
  }
  function getHandleFromText(element) {
    'e.g. abC dE -> abc-de'
    return element.textContent.toLocaleLowerCase().replace(/ /g, '-');
  }
  function addPixelValues(x, y) { 
    return parseInt(x.replace(/px/, "")) + parseInt(y.replace(/px/, "")) + "px";
  }
  function createScrollTransitionEffectsOnNavLinks() {
    if (!viewportWidthIsSmall()) {
      const topRootMargin = viewPortWidth < 960 ? 
      addPixelValues(STICKYHEADER.height.mobile, COLLECTIONSNAVIGATION.height.mobile) :
      addPixelValues(STICKYHEADER.height.desktop, COLLECTIONSNAVIGATION.height.desktop);

      const rootMargins = {
      top: topRootMargin,
      right: 0,
      bottom: `${window.innerHeight * .6}px`,
      left: 0
      }
      const options = {
      rootMargin: '-' + rootMargins.top + 
      ' 0px ' + 
      '-' + rootMargins.bottom + 
      ' 0px',
      threshold: 0.3 // The percentage of the element intersecting the root
      };
      const sections = document.querySelectorAll('.collection-item__header-wrapper');
      const observer = createNewIntersectionObserver(changeLinkToActiveState, [], options);

      sections.forEach(section => {
      observer.observe(section);
      });
    }
  }
  createScrollTransitionEffectsOnNavLinks();

  function transitClass(element, fromClass, toClass) {
    removeClass(element, fromClass);
    addClass(element, toClass);
  }
  function darkerToDark(element, darker='extra-dark-nav-link', dark='dark-nav-link') {
    transitClass(element, darker, dark);
  }
  function darkToDarker(element, darker='extra-dark-nav-link', dark='dark-nav-link') {
    transitClass(element, dark, darker);
  }
  function darkToNormal(element, dark='dark-nav-link') {
    removeClass(element, dark);
  }
  function lighterToLight(element, lighter='extra-light-nav-link', light='light-nav-link') {
    transitClass(element, lighter, light);
  }
  function lightToLighter(element, lighter='extra-light-nav-link', light='light-nav-link') {
    transitClass(element, light, lighter);
  }
  function lightToNormal(element, light='light-nav-link') {
    removeClass(element, light);
  }
  function getThemeEffects(theme) {
    if (theme == 'light') {
      return {
        currentTarget: lighterToLight,
        previousTarget: lightToNormal,
        nextTarget: lightToLighter
      }
    } 
    if (theme == 'dark') {
      return {
        currentTarget: darkerToDark,
        previousTarget: darkToNormal,
        nextTarget: darkToDarker       
      }
    }
  }

  function fadingTransitionEffectsOnNavLinks(links, theme, viewportWidth=500) {
    if (window.innerWidth <= viewportWidth) { 
    const options = {
      rootMargin: '0px -25% 0px -70%',
      threshold: 0.01 
    };
    const effects = getThemeEffects(theme);

    function changeStateOfLinks(entry, elements) {
      const prevLink = previousCousin(entry, 'li');
      const nextLink = nextCousin(entry, 'li');
  
      if (entry.isIntersecting) {
        effects.currentTarget(entry.target);
        if (nextLink) effects.nextTarget(nextLink.children[0]);
        if (prevLink) effects.previousTarget(prevLink.children[0]);
      }
    }
    const observer = createNewIntersectionObserver(changeStateOfLinks, [], options);

    links.forEach(link => {
      observer.observe(link);
    });
    }
  }
  const collectionNavLinks = getElementsWithClass('collection-nav-links');
  const stickyNavLinks = getElementsWithClass('sticky-navlinks');

  fadingTransitionEffectsOnNavLinks(collectionNavLinks, 'dark', 610);
  fadingTransitionEffectsOnNavLinks(stickyNavLinks, 'light');
});